// Whether a meeting is being recorded (or uploaded) in this page, for what
// lives outside the signed-in app: the PWA update toast (mounted at the
// root, main.tsx) keeps its Update button off while it is, because a reload
// stops the microphone. Set by RecorderProvider; tiny on purpose, so the
// toast does not pull the recorder into its bundle.

let active = false;
const listeners = new Set<() => void>();

export function setRecordingActive(on: boolean): void {
  if (on === active) return;
  active = on;
  listeners.forEach((fn) => fn());
}

export function recordingActive(): boolean {
  return active;
}

export function subscribeRecordingActive(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/**
 * The toast's Update button, or null for no toast at all: while a recording
 * runs here there is nothing to press (a reload would stop it), and a toast
 * with a dead button covered the recorder on a phone. The build waits and is
 * applied (or offered) once the recording is saved.
 */
export function updateButton(recording: boolean, updating: boolean): { disabled: boolean; label: string } | null {
  if (updating) return { disabled: true, label: "Updating…" };
  if (recording) return null;
  return { disabled: false, label: "Update" };
}
